if (!customElements.get('trade-in-form')) {
  class TradeInForm extends HTMLElement {
    constructor() {
      super();

      const dataEl = this.querySelector('script[type="application/json"]');
      this.data = dataEl ? JSON.parse(dataEl.textContent) : false;

      console.log(this.data);

      this.estimate = this.querySelector('[id^="TradeInEstimate-"]');
      this.conditionHelper = this.querySelector('[data-condition-helper]');

      this.brandPills = this.querySelectorAll('.tradein__pill');
      this.deviceDropdown = this.querySelector('[id^="TradeInDevice-"');
      this.conditionDropdown = this.querySelector('[id^="TradeInCondition-"');
      this.payoutDropdown = this.querySelector('[id^="TradeInPayout-"');

      this.brandContainer = this.querySelector('.tradein__content--brand');
      this.deviceContainer = this.querySelector('.tradein__content--device');
      this.conditionContainer = this.querySelector(
        '.tradein__content--condition'
      );
      this.payoutContainer = this.querySelector('.tradein__content--payout');

      this.customerContainer = this.querySelector(
        '.tradein__container--customer'
      );

      this.estimateContainer = this.querySelector(
        '.tradein__container--estimate'
      );

      this.brand = '';
      this.model = '';

      if (this.brandPills) {
        this.brandPills.forEach((pill) => {
          pill.addEventListener('change', this.onBrandChange.bind(this));
        });
      }

      if (this.deviceDropdown) {
        this.deviceDropdown.addEventListener('change', this.update.bind(this));
      }

      if (this.conditionDropdown) {
        this.conditionDropdown.addEventListener(
          'change',
          this.onConditionChange.bind(this)
        );
      }

      if (this.payoutDropdown) {
        this.payoutDropdown.addEventListener('change', this.update.bind(this));
      }
    }

    onConditionChange(e) {
      const condition = e.target.value;
      if (this.conditionHelper) {
        let htmlString = '';
        if (condition === 'excellent_condition') {
          htmlString = window.theme.strings.conditionExcellentHelper;
        } else if (condition === 'working_condition') {
          htmlString = window.theme.strings.conditionWorkingHelper;
        } else if (condition === 'broken_condition') {
          htmlString = window.theme.strings.conditionBrokenHelper;
        }

        // Split at colon and format
        const parts = htmlString.split(':');
        if (parts.length === 2) {
          this.conditionHelper.innerHTML = `<strong>${parts[0]}:</strong>${parts[1]}`;
        } else {
          this.conditionHelper.innerHTML = htmlString;
        }
      }
      this.update();
    }

    update() {
      this.model = this.deviceDropdown.value;
      this.condition = this.conditionDropdown.value;
      this.payout = this.payoutDropdown.value;

      const modelData = this.data[this.brand].find(
        (model) => model.product_name === this.model
      );

      if (modelData[this.condition]) {
        var price = window.theme.settings.moneyFormat.replace(
          /{{amount}}/g,
          parseFloat(modelData[this.condition].amount).toFixed(2)
        );

        this.estimate.innerText = price;
      } else {
        this.estimate.innerText = window.theme.strings.tradeInNotAvailable;
      }
    }

    onBrandChange(e) {
      this.brand = e.target.value;

      if (this.brand != '') {
        if (this.data[this.brand]) {
          this.deviceDropdown.innerHTML = ''; // Clear existing options

          this.data[this.brand].forEach((model) => {
            const option = document.createElement('option');
            option.value = model.product_name;
            option.innerText = model.product_name;
            this.deviceDropdown.appendChild(option);
          });

          this.showForm();
          this.update();
        }
      } else {
        this.resetForm();
      }
    }

    showForm() {
      this.deviceContainer.classList.remove('hidden');
      this.conditionContainer.classList.remove('hidden');
      this.payoutContainer.classList.remove('hidden');

      this.customerContainer.classList.remove('hidden');
      this.estimateContainer.classList.remove('hidden');
    }

    resetForm() {
      this.deviceContainer.classList.add('hidden');
      this.conditionContainer.classList.add('hidden');
      this.payoutContainer.classList.add('hidden');

      this.customerContainer.classList.add('hidden');
      this.estimateContainer.classList.add('hidden');

      this.deviceContainer.innerHTML = '';
      this.conditionDropdown.selectedIndex = 0;
      this.payoutDropdown.selectedIndex = 0;
    }
  }

  customElements.define('trade-in-form', TradeInForm);
}
